/* eslint-disable @next/next/no-img-element */
import React from "react";
import styled from "styled-components";
import CustomerSupportBannerFace from "@/images/supportBanner/CustomerSupportBannerFace.png";
import mediaQueries from "@/styles/mediaQueries";

const StyledCard = styled.div<{ $variant: "default" | "sidebar" }>`
  display: flex;
  gap: 1rem;
  align-items: center;
  width: 100%;
  flex-direction: column;
  text-align: center;
  background: white;
  padding: 16px;
  border-radius: ${({ theme }) => theme.kallisto.border.radius.radius100};
  border: 1px solid ${({ theme }) => theme.kallisto.color.border.static.borderNeutral};
  ${({ $variant }) =>
    $variant === "sidebar"
      ? mediaQueries.screenSmMin`
          flex-direction: row;
          text-align: left;
        `
      : mediaQueries.screenMdMin`
          flex-direction: row;
          text-align: left;
        `};
  ${({ $variant }) =>
    $variant === "sidebar"
      ? mediaQueries.screenMdMin`
          flex-direction: column;
          text-align: center;
        `
      : ""};
`;

const ImgContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 80px;
  max-height: 80px;
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid
    ${({ theme }) =>
    theme.kallisto.color.background.interactive.backgroundPrimaryDefault};

  img {
    max-width: 100%;
    max-height: 100%;
  }
`;

const TextContainer = styled.div`
  h3 {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    color: ${({ theme }) =>
    theme.kallisto.color.text.interactive.textPrimaryDefault};
  }
  p {
    font-size: 14px;
    line-height: 20px;
  }
`;

const StyledP = styled.p`
  margin-bottom: 0.5rem;
`;
const StyledLink = styled.a`
  color: ${({ theme }) =>
    theme.kallisto.color.text.interactive.textPrimaryDefault} !important;
  font-weight: 700;
`;

interface CustomerSupportBannerProps {
  title: string | undefined;
  text: string | undefined;
  phoneNumber: string | undefined;
  timeSchedulePrefix: string | undefined;
  timeSchedule: string | undefined;
  timeSchedule2: string | undefined;
  variant?: "default" | "sidebar";
}

export default function CustomerSupportBanner({
  title,
  text,
  phoneNumber,
  timeSchedulePrefix,
  timeSchedule,
  timeSchedule2,
  variant = "default",
}: CustomerSupportBannerProps) {
  return (
    <StyledCard $variant={variant}>
      <ImgContainer>
        <img
          src={CustomerSupportBannerFace.src}
          alt="Kundensupport-Banner"
          width={80}
          height={80}
        />
      </ImgContainer>
      <TextContainer>
        <h3>{title}</h3>
        <StyledP>{text}</StyledP>
        <StyledP>
          <StyledLink href={`tel:${phoneNumber}`}>{phoneNumber}</StyledLink>{" "}
          {" | "}
          {timeSchedulePrefix}
        </StyledP>
        <p>{timeSchedule}</p>
        {timeSchedule2 && <p>{timeSchedule2}</p>}
      </TextContainer>
    </StyledCard>
  );
}
